import * as pbi from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import { useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import ResponsiveAppBar from '../components/navbar.component';

/** MUI */
import {
    Box,
    Button,
    Container,
    Stack
} from '@mui/material';

/**Servicios */
import tokenService from "../services/token.service";

const PersonalPBI = () => {
    const [token, setToken] = useState('');
    const [report, setReport] = useState('');
    const navigate = useNavigate();
    const { id_contrato } = useParams();
    const [user, setUser] = useState('');
    const [id_report, setIDReport] = useState('');

    useEffect(() => {
        const usuario = JSON.parse(localStorage.getItem("usuario"));
        asignarIDreporteContrato(id_contrato);
        setUser(usuario);
    }, []);

    function asignarIDreporteContrato(id_contrato) {
        if (id_contrato === "1D7v7XooMPqwWw02Ciww") {
            setIDReport("740fc2181503aa6ddcd9");
        }
    }

    async function getTokenB() {
        let t = await tokenService.getTokenB();
        setToken(t.data.accessToken);
    };

    const fullScreeen = () => {
        if (!report) {
            return;
        }
        report.fullscreen();
    };

    return (
        <div>
            <ResponsiveAppBar id_contrato={id_contrato} id_empresa={user.id_empresa} />
            <Container maxWidth="xl">
                <Box sx={{ margin: 3 }}>
                    <Box sx={{
                        margin: 3,
                        justifyContent: "start",
                        alignItems: "start",
                        display: "flex"
                    }}>
                        {/* <Button variant="contained" color="secondary" onClick={user.perfil === "gerencia" ? () => navigate("/reportegerencial") : () => navigate("/reporterrhh")}>Volver</Button> */}
                    </Box>
                    <PowerBIEmbed
                        embedConfig={{
                            type: 'report',   // Supported types: report, dashboard, tile, visual and qna
                            id: '3b94cdc9-3ccc-4d48-a48d-5dab6c5a03f9',
                            embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=3b94cdc9-3ccc-4d48-a48d-5dab6c5a03f9&groupId=796572a5-c75a-4662-bfd1-30d9c0ff8be3&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVBBQVMtMS1TQ1VTLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZSwiZGlzYWJsZUFuZ3VsYXJKU0Jvb3RzdHJhcFJlcG9ydEVtYmVkIjp0cnVlfX0%3d',
                            accessToken: token,//'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Im5PbzNaRHJPRFhFSzFqS1doWHNsSFJfS1hFZyIsImtpZCI6Im5PbzNaRHJPRFhFSzFqS1doWHNsSFJfS1hFZyJ9.eyJhdWQiOiJodHRwczovL2FuYWx5c2lzLndpbmRvd3MubmV0L3Bvd2VyYmkvYXBpIiwiaXNzIjoiaHR0cHM6Ly9zdHMud2luZG93cy5uZXQvZTk0NDk3ZDEtMTYxZi00Y2U5LWE0ZDgtYzcxODA1ZDAyYTZiLyIsImlhdCI6MTYyMjU3NjU0OCwibmJmIjoxNjIyNTc2NTQ4LCJleHAiOjE2MjI1ODA0NDgsImFjY3QiOjAsImFjciI6IjEiLCJhaW8iOiJBVFFBeS84VEFBQUFLSHJ0ZW05TU5UaEJpK0RObnJmUWcvNWc0bnpqa2p1bGpOZGgvU1dvdTlaeVo1dDR5bHU5eWxwSDcyZms4NGtsIiwiYW1yIjpbInB3ZCJdLCJhcHBpZCI6ImU0MmY3ZmIxLWRkOWMtNGRhYi1hNDJhLTFlNjQ2YmI1YmE0ZCIsImFwcGlkYWNyIjoiMSIsImZhbWlseV9uYW1lIjoiTGFndWVzIiwiZ2l2ZW5fbmFtZSI6IlBhYmxvIiwiaXBhZGRyIjoiMTkwLjE1MS40My4xMTQiLCJuYW1lIjoiUGFibG8gTGFndWVzIiwib2lkIjoiNWM3MzFlZGQtYmM5ZS00OTI1LTlmNDQtMjY1ZjYyOTBkNjVlIiwicHVpZCI6IjEwMDMyMDAxMkMxRDkyNDAiLCJyaCI6IjAuQVh3QTBaZEU2UjhXNlV5azJNY1lCZEFxYTdGX0wtU2MzYXROcENvZVpHdTF1azE4QVBvLiIsInNjcCI6IkFwcC5SZWFkLkFsbCBDYXBhY2l0eS5SZWFkLkFsbCBDYXBhY2l0eS5SZWFkV3JpdGUuQWxsIENvbnRlbnQuQ3JlYXRlIERhc2hib2FyZC5SZWFkLkFsbCBEYXNoYm9hcmQuUmVhZFdyaXRlLkFsbCBEYXRhZmxvdy5SZWFkLkFsbCBEYXRhZmxvdy5SZWFkV3JpdGUuQWxsIERhdGFzZXQuUmVhZC5BbGwgRGF0YXNldC5SZWFkV3JpdGUuQWxsIEdhdGV3YXkuUmVhZC5BbGwgR2F0ZXdheS5SZWFkV3JpdGUuQWxsIFJlcG9ydC5SZWFkLkFsbCBSZXBvcnQuUmVhZFdyaXRlLkFsbCBTdG9yYWdlQWNjb3VudC5SZWFkLkFsbCBTdG9yYWdlQWNjb3VudC5SZWFkV3JpdGUuQWxsIFdvcmtzcGFjZS5SZWFkLkFsbCBXb3Jrc3BhY2UuUmVhZFdyaXRlLkFsbCIsInN1YiI6Ii10YjhWRmZVX25RODI3SndmelQwVWJOOXdhRUFlQS1laS00NXZ6Y3o0UGMiLCJ0aWQiOiJlOTQ0OTdkMS0xNjFmLTRjZTktYTRkOC1jNzE4MDVkMDJhNmIiLCJ1bmlxdWVfbmFtZSI6InBsYWd1ZXNAc2VydmljaW9zNGouY2wiLCJ1cG4iOiJwbGFndWVzQHNlcnZpY2lvczRqLmNsIiwidXRpIjoidnB1eXBmcm0xa3lsWDR5M0o4VkFCQSIsInZlciI6IjEuMCIsIndpZHMiOlsiNjJlOTAzOTQtNjlmNS00MjM3LTkxOTAtMDEyMTc3MTQ1ZTEwIiwiYTllYTg5OTYtMTIyZi00Yzc0LTk1MjAtOGVkY2QxOTI4MjZjIiwiYjc5ZmJmNGQtM2VmOS00Njg5LTgxNDMtNzZiMTk0ZTg1NTA5Il19.KqI6g-BfxOGTT2Y3eX5JynViYFYtlczOBX4P-C1LrjR8C0vJgdprYn9OVPtDu2AkLy8O5fPdTyYv65Yn-8m8nEVxJgRxWYOi8d6ckkc4bAPLZkcha0UreKnJVeUc2CCJ-eJT2z7yOtr49seTdJ7mn4BpeZ0jywCpbE5HV5eMdQZjN7kbmFG9jt90Xghv0fGr4vNgCIw79iy7-C6g4GEZvDi3rheboqTdZJViKJjPdPmapBaPfg28mzSWOh6C9XdrRvSwFIbcX6OmowJYfGVzZbNuzjKcok1DV9PBrZ0Qhe0shZcEDqaQSp3A2MvU-Eyax7mdAFDUmdLzsHp1BwpNDA',
                            tokenType: pbi.models.TokenType.Aad,
                            allowFullScreen: true,
                            pageName: id_report,//this.state.direccion,//"ReportSection796368f112623c7c2480",//"ReportSection7fb3bfeab3521003c946",//ReportSection796368f112623c7c2480
                            settings: {
                                panes: {
                                    filters: {
                                        expanded: false,
                                        visible: false
                                    },
                                    pageNavigation: {
                                        visible: false
                                    }
                                }
                            }
                        }}

                        getEmbeddedComponent={(embeddedReport) => {
                            getTokenB();
                            console.log(`Embedded object of type "${embeddedReport.embedtype}" received en reporte direccion`);
                            setReport(embeddedReport);
                            window.report = embeddedReport;
                        }}

                        eventHandlers={
                            new Map([
                                ['loaded', function () { console.log('Report loaded'); }],
                                ['rendered', function () { console.log('Report rendered'); }],
                                ['error', function (event) { console.log(event.detail); }]
                            ])
                        }

                        cssClassName={"Embed-container"}
                    />
                </Box>
                <Box sx={{
                    margin: 3,
                    justifyContent: "center",
                    alignContent: "center",
                    alignItems: "center",
                    display: "flex"
                }}>
                    <Stack direction="row" spacing={10}>
                        <Button variant='contained' sx={{ backgroundColor: 'black' }} onClick={fullScreeen}>PANTALLA COMPLETA</Button>
                        {/* <Button variant='contained' sx={{backgroundColor: 'black'}} onClick={() => navigate("/")}>VER DETALLE</Button> */}
                    </Stack>
                </Box>
            </Container>
        </div>
    )
}

export default PersonalPBI;